<div class="homepage-section-header">
  THE PLEASURE IS ALWAYS OURS (AND THEIRS)
  <div class="homepage-section-subheader">See why people are loving {{ PRODUCT_NAME }}.</div>
</div>
<app-carousel-main
  class="carousel"
  [numItems]="carouselConfig?.numItems"
  [itemGap]="carouselConfig?.itemGap"
  [showArrowBackground]="false"
  [alwaysShowArrows]="true"
  [arrowBackgroundOffset]="0"
  [arrowColorDark]="false"
  [blockSelection]="false"
  [maintainRatio]="0"
  [persistentArrowBackground]="true"
>
  <ng-container *ngFor="let t of testimonials">
    <div
      class="testimonial-item-wrapper"
      *appCarouselItem
    >
      <app-homepage-testimonial [testimonial]="t"></app-homepage-testimonial>
    </div>
  </ng-container>
</app-carousel-main>
